'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ErrorDataUnavailable } from '@/components/common/Error';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';
export interface VaultV2YourTransactionsErrorProps {
  title: string;
}
const VaultV2YourTransactionsError = t0 => {
  const $ = _c(5);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <SubSectionTitle>{title}</SubSectionTitle>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ErrorDataUnavailable minHeight="478px" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="gap-sm flex flex-col">{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default memo(VaultV2YourTransactionsError);